export default "__VITE_ASSET__C94F_B9q__"